import {useContext} from 'react';

import {Field} from 'formik';

import {SxProps} from '@mui/material';

import {EmpionSelectField} from '../EmpionSelectField/EmpionSelectField';

import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import {DACH_COUNTRY_CODES} from '../../lib/constants';

interface Props {
  name: string;
  label: string;
  fullWidth?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  sx?: SxProps;
  size?: 'small' | 'medium';
}
export const DachCountrySelect = ({name, label, onChange, fullWidth, value, sx, size = 'small'}: Props) => {
  const language = useContext(LanguageContext);
  const options = DACH_COUNTRY_CODES.map((option) => ({
    id: option.id,
    label: option.label[language],
  }));
  return (
    <Field
      type='text'
      name={name}
      value={value}
      onChange={onChange}
      label={label}
      component={EmpionSelectField}
      options={options}
      fullWidth={fullWidth}
      sx={sx}
      size={size}
    />
  );
};
